import React, { useContext } from 'react';

import { Label, Square } from '../InfoCard/InfoCard.styles';
import { I18nProviderContext } from 'contexts/I18nProvider';
import { Graphics, User, HeartFeedback } from './components/Icons/Icons';
import { Tooltip } from 'App/Components/Tooltip/Tooltip';
import {
	Wrapper,
	Container,
	ContainerCentralize,
	ContainerProgressHeader,
} from './Header.styles';

export const Header = () => {
	const { translate } = useContext(I18nProviderContext);

	return (
		<Wrapper>
			<Container>
				<Label fontWeight={500} fontSize="12px">
					Total
				</Label>
				<Label fontSize="14px">
					{translate('views.campaigns.evaluations.progress.header.workCenter')}
				</Label>
				<ContainerProgressHeader>
					<Label fontWeight={500} fontSize="14px">
						{translate('views.campaigns.evaluations.progress.header.responses')}
					</Label>
					<div className="graphic-icon">
						<Tooltip
							content={translate(
								'views.campaigns.evaluations.progress.header.tooltip.chart',
							)}
						>
							<Graphics />
						</Tooltip>
					</div>
				</ContainerProgressHeader>
				<ContainerCentralize>
					<Tooltip
						content={translate(
							'views.campaigns.evaluations.progress.header.tooltip.user',
						)}
					>
						<User />
					</Tooltip>
				</ContainerCentralize>
				<Tooltip
					content={translate(
						'views.campaigns.evaluations.progress.header.tooltip.heartFeedback',
					)}
				>
					<HeartFeedback />
				</Tooltip>
			</Container>
			<Square />
		</Wrapper>
	);
};
